<template>
  <div class="page-component-wrapper">
    <grid
      :config="gridConfig"
      @handleCustomButtonGrid="goToQuickRFQ"
    />
    <editor
      :disabled="isDisabledForm"
      :config="{id: gridConfig.id, api: 'Parts/Get/'}"
      @on-quick-rfq="goToQuickRFQ"
    />
  </div>
</template>

<script>
import gridConfig from './GridConfig.js'

export default {
  name: 'PartsIndex',
  components: {
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index'),
    'editor': () => import(/* webpackChunkName: 'Parts' */ './Editor')
  },
  data () {
    return {
      gridConfig: gridConfig
    }
  },
  computed: {
    isDisabledForm () {
      return !this.permission(this.$store.getters.get('permissions'), 'isAllowToEditParts')
    }
  },
  methods: {
    goToQuickRFQ ({ row }) {
      let query = {
        'quick-rfq-part': `edit[${row.id}]`,
        'quick-rfq-part-stock-id': row.stockID,
        'quick-rfq-part-rfq2-id': row.rfq2ID
      }
      query = JSON.parse(JSON.stringify(query))
      this.$router.push({
        name: 'RFQQuickRFQPartAll',
        query
      })
    }
  }
}
</script>
